module.exports = __webpack_public_path__ + "img/dae997a.svg";